<div class="abacus-error-notice" [class.is-hint]="isHint" *ngIf="plainText">
  <i [class]="iconClass + ' notice-icon'"></i>
  <div class="notice-body">
    <div class="notice-title">
      {{ title }}<span *ngIf="stand"> · Stand {{ stand }}</span>
      <span *ngIf="distinctCount > 1" class="notice-count"
        >{{ distinctCount }} verschiedene</span
      >
      <span *ngIf="messageCount > 1" class="notice-attempts"
        >{{ messageCount }} Übertragungen</span
      >
    </div>

    <div *ngIf="!expanded" class="notice-text">{{ preview }}</div>

    <div *ngIf="expanded">
      <div class="notice-text notice-text-full">{{ plainText }}</div>
      <div *ngIf="newestRepeats > 1" class="notice-repeat">
        {{ newestRepeats }}× aufgetreten, zuletzt {{ stand }}
      </div>

      <div *ngFor="let group of older" class="notice-older">
        <div class="notice-older-date">
          {{ formatTimestamp(group.newest) }}
          <span *ngIf="group.count > 1">· {{ group.count }}×</span>
        </div>
        <div class="notice-text">{{ group.text }}</div>
      </div>
    </div>

    <button *ngIf="isLong" type="button" class="notice-toggle" (click)="toggle()">
      {{ toggleLabel }}
    </button>
  </div>
</div>
